import { IRenderFormField } from "src/@types/form";
import { TextInput } from "src/components/FormField/TextInput";
import { ContactUsField } from "../types";

export const CONTACT_US_FORM_FIELDS: IRenderFormField[] = [
  {
    component: TextInput,
    placeholder: "Ваше ім’я",
    name: ContactUsField.name,
  },
  {
    component: TextInput,
    type: "tel",
    placeholder: "Номер телефону",
    name: ContactUsField.phone,
  },
  {
    component: TextInput,
    placeholder: "Email",
    name: ContactUsField.email,
  },
  {
    component: TextInput,
    placeholder: "Питання",
    className:
      "min-h-20 max-h-24 3xl:min-h-37.5 3xl:max-h-62.5 overflow-y-scroll",
    name: ContactUsField.question,
    isTextArea: true,
  },
];
